/**
 * The Bungie API key for the website (bungie.net/en/Application, app "d2companion"). It is not a secret: every
 * browser sends it with each request, and Bungie only accepts it from https://d2companion.co.za (the Origin header
 * set on the app). The client secret is NOT here; it lives on the server as a Cloudflare secret.
 */
export const BUNGIE_API_KEY = '93a2d06b561b48efb6cdab150cf41883';

/** Where pictures and the game database come from (always Bungie itself). */
export const BUNGIE_ROOT = 'https://www.bungie.net';

/**
 * Where API requests go: Bungie itself on the live site; Vite's proxy while developing on this PC, because Bungie only
 * accepts the key from the real domain (see vite.config.ts).
 */
export const API_ROOT = import.meta.env.DEV || location.hostname === 'localhost' ? '/bungie' : BUNGIE_ROOT;

/** Match reports (post game carnage reports) only come from Bungie's stats host. */
export const STATS_ROOT = import.meta.env.DEV || location.hostname === 'localhost' ? '/bungie-stats' : 'https://stats.bungie.net';
